<script setup>
import { computed } from 'vue';

const props = defineProps({
  status: {
    type: String,
    default: '',
  },
});

const normalizedStatus = computed(() => (props.status || '').toUpperCase());

const badgeClass = computed(() => {
  switch (normalizedStatus.value) {
    case 'APPROVED':
      return 'bg-n-teal-3 text-n-teal-11';
    case 'REJECTED':
    case 'DISABLED':
    case 'PAUSED':
      return 'bg-n-ruby-3 text-n-ruby-11';
    default:
      return 'bg-n-amber-3 text-n-amber-11';
  }
});
</script>

<template>
  <span
    class="inline-flex items-center px-2 py-0.5 text-xs font-medium rounded-md"
    :class="badgeClass"
  >
    {{ normalizedStatus }}
  </span>
</template>
